import React from 'react';
import DesktopHeader from './DesktopHeader';
import DesktopTabs from './DesktopTabs';
import DesktopPortfolioTab from './DesktopPortfolioTab';
import DesktopPropertiesTab from './DesktopPropertiesTab';
import DesktopResponsesTab from './DesktopResponsesTab';
import DesktopQRTab from './DesktopQRTab';
import DesktopPropertyDrawer from './DesktopPropertyDrawer';
import { CircularLoader } from '../../ui';

const DesktopLayout = ({
  activeTab,
  setActiveTab,
  propertyTab,
  portfolio,
  loadingState,
  availableTags
}) => {
  return (
    <div className="flex flex-col h-full bg-white relative overflow-hidden">
      {/* Circular loader - shows during actual data operations */}
      <CircularLoader
        isLoading={loadingState?.isLoading}
        overlay={true}
        size="lg"
      />

      {/* Header */}
      <header className="flex-shrink-0 border-b border-notion-border px-8 pt-6 pb-0 bg-white z-20 flex flex-col gap-6">
        <DesktopHeader portfolio={portfolio} />
        <DesktopTabs activeTab={activeTab} setActiveTab={setActiveTab} />
      </header>

      {/* Content */}
      <div className="flex-1 overflow-y-auto bg-stone-50/50 p-8">
        {activeTab === 'portfolio' && portfolio && (
          <DesktopPortfolioTab portfolio={portfolio} availableTags={availableTags} />
        )}

        {activeTab === 'properties' && (
          <DesktopPropertiesTab
            properties={propertyTab.properties}
            onAddProperty={propertyTab.handleAddProperty}
            onPropertyClick={(id) => propertyTab.handlePropertyClick(id)}
          />
        )}

        {activeTab === 'responses' && (
          <DesktopResponsesTab propertyTab={propertyTab} portfolio={portfolio} />
        )}

        {activeTab === 'qr' && (
          <DesktopQRTab propertyTab={propertyTab} portfolio={portfolio} />
        )}
      </div>

      {/* Property Drawer */}
      <DesktopPropertyDrawer
        propertyTab={propertyTab}
        availableTags={availableTags}
      />
    </div>
  );
};

export default DesktopLayout;
